import { FC, PropsWithChildren, useMemo, useState } from 'react';
import HelpCenterContext from '../model/HelpCenterContext';

const HelpCenterProvider: FC<PropsWithChildren> = ({ children }) => {
  const [isHelpCenterOpened, setIsHelpCenterOpened] = useState<boolean>(false);
  const [helpQuestionId, setHelpQuestionId] = useState<number | null>(null);
  const [questions, setQuestions] = useState<Question[]>([]);
  const [targetQuestionTitle, setTargetTargetQuestionTitle] =
    useState<string>('');

  const defaultValues = useMemo(
    () => ({
      isHelpCenterOpened,
      setIsHelpCenterOpened,
      questions,
      setQuestions,
      helpQuestionId,
      setHelpQuestionId,
      targetQuestionTitle,
      setTargetTargetQuestionTitle,
    }),
    [
      isHelpCenterOpened,
      setIsHelpCenterOpened,
      questions,
      setQuestions,
      helpQuestionId,
      setHelpQuestionId,
      targetQuestionTitle,
      setTargetTargetQuestionTitle,
    ]
  );

  return (
    <HelpCenterContext.Provider value={defaultValues}>
      {children}
    </HelpCenterContext.Provider>
  );
};

export default HelpCenterProvider;
